import { ConfirmDialog } from "@/components/ui/ConfirmDialog";

interface AuditStatusConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actionLabel: string;
  targetStatusLabel: string;
  isPending: boolean;
}

export function AuditStatusConfirmModal({
  open,
  onClose,
  onConfirm,
  actionLabel,
  targetStatusLabel,
  isPending,
}: AuditStatusConfirmModalProps) {
  return (
    <ConfirmDialog open={open} onClose={onClose}>
      <ConfirmDialog.Title>Confirm: {actionLabel}</ConfirmDialog.Title>
      <ConfirmDialog.Body>
        <p className="text-sm text-secondary">
          Are you sure you want to move this audit to{" "}
          <span className="font-medium text-primary">{targetStatusLabel}</span>?
        </p>
      </ConfirmDialog.Body>
      <ConfirmDialog.Actions
        onConfirm={onConfirm}
        confirmLabel={actionLabel}
        loading={isPending}
      />
    </ConfirmDialog>
  );
}
